import {
  AUTOCOMPLETE_SEARCH_USERS_IN_PROGRESS,
  AUTOCOMPLETE_SEARCH_USERS_SUCCESS,
  AUTOCOMPLETE_SEARCH_USERS_FAILURE,
  AUTOCOMPLETE_SEARCH_USERS_CLEAR
} from "./actions";

const initialState = {
  isLoading: false,
  usersList: []
};

export const autoCompleteData = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {

    case AUTOCOMPLETE_SEARCH_USERS_IN_PROGRESS:
    return {
      ...state,
      isLoading: true
    };

    case AUTOCOMPLETE_SEARCH_USERS_SUCCESS:
    const { data } = payload;
    return {
      ...state,
      isLoading: false,
      usersList: data
    };

    case AUTOCOMPLETE_SEARCH_USERS_FAILURE:
    return {
      ...state,
      isLoading: false
    };

    case AUTOCOMPLETE_SEARCH_USERS_CLEAR:
      return {
        ...state,
        isLoading: false,
        usersList: []
      };

    default:
      return state;
  }
};
